import typeUtils from './typeUtils.js.es6';

const uiUtils = {
    mergeClassNames: function(arr, className){
        let _css = arr;
        if(!Array.isArray(_css)){
            throw new TypeError('Method uiUtils.mergeClassNames expected arr to be of type Array, but got ' + typeof arr + ' instead.');
        }

        if(typeUtils.isString(className) && className.length > 0){
            _css = _css.concat(className.split(' '))
        }

        return _css.join(' ');
    },
    addClass: function (arr, className) {
        if (Array.isArray(arr)) {
            if (arr.indexOf(className) === -1) {
                arr.push(className);
            }
        }
        return arr;
    },

    removeClass: function (arr, className) {
        if (Array.isArray(arr)) {
            if (arr.indexOf(className) > -1) {
                arr.splice(arr.indexOf(className), 1);
            }
        }
        return arr;
    }
};

export default uiUtils;